import { create } from 'zustand';

// Contador de peticiones Axios en curso.
// show() se llama en el request interceptor, hide() en el response interceptor.
// Cualquier componente puede leer isActive para reaccionar al estado global.

interface LoadingState {
  count: number;
  show: () => void;
  hide: () => void;
}

export const useLoadingStore = create<LoadingState>()((set) => ({
  count: 0,
  show: () => set((s) => ({ count: s.count + 1 })),
  hide: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));
